"use client"

import { router, usePage } from "@inertiajs/react"
import { Monitor01, Trash01 } from "@untitledui/icons"

import { BadgeWithDot } from "@/components/ui/badge"
import { Button } from "@/components/ui/button"
import { SectionHeader } from "@/components/ui/section-header"
import { Table, TableCard } from "@/components/ui/table"
import SettingsLayout from "@/layouts/settings/layout"
import { sessionPath } from "@/routes"

interface Session {
  id: number
  user_agent: string
  ip_address: string
  created_at: string
}

export default function Sessions() {
  const { sessions } = usePage().props as unknown as { sessions: Session[] }

  const revoke = (id: number) => {
    if (confirm("Are you sure you want to revoke this session?")) {
      router.delete(sessionPath({ id }))
    }
  }

  return (
    <SettingsLayout>
      <div className="flex flex-col gap-6 px-4 lg:px-8">
        <SectionHeader.Root>
          <SectionHeader.Group>
            <div className="flex flex-1 flex-col justify-center gap-0.5 self-stretch">
              <SectionHeader.Heading>Active Sessions</SectionHeader.Heading>
              <SectionHeader.Subheading>
                Manage your active sessions on other devices.
              </SectionHeader.Subheading>
            </div>
          </SectionHeader.Group>
        </SectionHeader.Root>

        <TableCard.Root>
          <Table aria-label="Sessions">
            <Table.Header>
              <Table.Head>Device</Table.Head>
              <Table.Head>IP Address</Table.Head>
              <Table.Head>Signed In</Table.Head>
              <Table.Head>Status</Table.Head>
              <Table.Head>Action</Table.Head>
            </Table.Header>
            <Table.Body items={sessions}>
              {(session) => (
                <Table.Row id={session.id}>
                  <Table.Cell>
                    <div className="flex items-center gap-3">
                      <Monitor01 className="text-fg-quaternary size-5" />
                      <span className="text-primary text-sm font-medium">
                        {session.user_agent}
                      </span>
                    </div>
                  </Table.Cell>
                  <Table.Cell>{session.ip_address}</Table.Cell>
                  <Table.Cell>
                    {new Date(session.created_at).toLocaleDateString()}
                  </Table.Cell>
                  <Table.Cell>
                    <BadgeWithDot color="success" size="sm">
                      Active
                    </BadgeWithDot>
                  </Table.Cell>
                  <Table.Cell>
                    <Button
                      iconLeading={Trash01}
                      size="sm"
                      color="tertiary-destructive"
                      onClick={() => revoke(session.id)}
                    />
                  </Table.Cell>
                </Table.Row>
              )}
            </Table.Body>
          </Table>
        </TableCard.Root>
      </div>
    </SettingsLayout>
  )
}
